import {
	Quad,
	QuadEightyTwentyRange,
	QuadEightyTwenty,
} from '../interfaces/quad.interface';

export function determineEightyTwenty(percent: number): QuadEightyTwenty {
	if (percent <= QuadEightyTwentyRange.Eighty) return '80';
	return '20';
}

export function determineQuadByEightyTwenty(
	customer: QuadEightyTwenty,
	product: QuadEightyTwenty,
): Quad {
	if (customer === '80' && product === '80') return 1;
	if (customer === '80' && product === '20') return 2;
	if (customer === '20' && product === '80') return 3;
	return 4;
}

export const quadDisplay = (quad: Quad) => `Q${quad}`;

export function canShowPlots(count: number | undefined, max: number) {
	if (typeof count === 'undefined') return true;
	return count <= max;
}
